"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  sk: {
    treeSearchPlaceholder: '请输入关键字进行过滤',
    loading: '正在加载中...',
    number: '序号',
    tip: '提示',
    createTime: '创建时间',
    ing: '系统正在处理中，请稍等...',
    init: '正在初始化...',
    operation: '操作',
    status: '状态',
    create: '创建',
    download: '导出',
    title: '标题',
    type: '类型',
    sort: '排序',
    edit: '编辑',
    publish: '发布',
    "delete": '删除',
    search: '搜索',
    cancel: '取消',
    confirm: '确认',
    loginAgain: '重新登录',
    decideGoOut: '确认登出',
    confirmPws: '请确认密码',
    adminPws: '请输入管理员密码',
    timestamp: '请选择日期时间',
    select: '请选择',
    input: '请输入',
    more: '更多',
    time: '时间',
    describe: '描述',
    executing: '任务执行中',
    nextStep: '下一步',
    preStep: '上一步',
    back: '返回',
    refresh: '刷新',
    showMore: '查看更多',
    navbar: {
      chinese: '简体中文',
      logout: '注销',
      english: 'English',
      screenfull: '',
      user: '',
      language: '',
      welcome: '欢迎您，',
      customerService: '在线客服',
      modifyPassword: '修改密码',
      initialConfig: '初始化配置向导',
      alarm: '告警',
      about: '关于',
      mores: ''
    },
    route: {
      nav: 'nav',
      nav1: 'nav1'
    },
    lv: {
      name: '姓名',
      email: '邮箱',
      phone: '电话',
      address: '地址'
    },
    about: {
      version: '软件版本号信息',
      bbs: '技术支持论坛',
      hotline: '技术服务热线',
      service: '技术支持',
      supports: '本系统支持：Chrome浏览器、Firefox',
      resolution: '默认支持1600×900 ，推荐使用1600*900分辨率'
    },
    form: {
      common_term_null_valid: '必填项',
      common_term_null_pre_valid: '请输入',
      common_term_length_valid: '长度范围是{min}到{max}位',
      common_term_maxlength_valid: '长度不能超过{max}位',
      common_term_length_valid1: '请输入{length}位字符',
      common_term_special_symbol_valid: '不能含有特殊字符，如：@#￥%',
      common_global_name_valid: '只能输入字母、数字、汉字、横线以及下划线',
      common_user_email_valid: '请输入正确的邮箱',
      common_user_email_already_existed_valid: '邮箱地址已存在',
      common_user_agree_valid: '请同意',
      common_term_minLength_valid: '输入内容至少{minLength}位',
      common_term_int_valid: '请输入整数',
      common_term_port_valid: '请输入有效的端口号（1-65535）',
      common_term_number_valid: '请输入数字',
      common_term_lt_valid: '输入内容应小于{lt}',
      common_term_lte_valid: '输入内容不能大于{lte}',
      common_term_gt_valid: '输入内容应大于{gt}',
      common_term_gte_valid: '输入内容不能小于{gte}',
      common_term_maxDecimalLength_valid: '该输入项最多接受{maxDecimalLength}位小数',
      common_term_phone_valid: '请输入正确的手机号',
      common_term_email_valid: '请输入正确的邮箱地址',
      common_term_verifyCode_valid: '请输入正确的验证码',
      common_term_cname_valid: '只包含中英文，数字，“_”，“-”，“@”，“.”且不能以“_”开头',
      common_term_url_valid: '请输入正确url地址',
      common_term_lowercase_valid: '请输入小写字母',
      common_term_uppercase_valid: '请输入大写字母',
      common_term_IP_valid: '请输入正确IP地址',
      common_term_mask_valid: '请输入正确子网掩码',
      common_disabled_named_valid: '不能使用"admin", "public", "local", "guest"保留字段命名',
      common_not_only_space_valid: '输入的内容不允许全为空格',
      common_hexadecimal_number_valid: '请输入有效的十六进制（只允许数字、字母a-f、A-F）',
      common_term_ipRangeCheck_valid: '请在指定IP段内输入正确的IP地址',
      common_num_lt_valid: '个数不能超过{num}个',
      common_term_file_size_valid: '请上传大于0KB的文件',
      common_term_file_valid: '请选择上传文件',
      common_term_password_null_valid: '请输入密码',
      common_empty_string_valid: '输入的内容不允许全为空格',
      common_charAndNum_string_valid: '请输入大小写字母、数字、特殊字符中三种及以上的密码组合，其中特殊字符只包含：`~!@#$%^&*()_-+=<>?:"{}|,./;[]' + '\\' + "'和空格",
      common_hard_passowrd_string_valid: '请输入大小写字母、数字、特殊字符的密码组合，其中特殊字符只包含：`~!@#$%^&*()_-+=<>?:"{}|,./;[]' + '\\' + "'和空格",
      common_right_ip_valid: '请输入正确的IP地址',
      common_available_ip_valid: '请输入可用的IP地址'
    },
    serviceError: {
      0: '服务器不可用',
      400: '请求出错',
      401: '未授权，请登录',
      403: '拒绝访问',
      404: '请求地址出错',
      408: '请求超时',
      500: '服务器内部错误',
      501: '服务未实现',
      502: '网关错误',
      503: '服务不可用',
      504: '网关超时',
      505: 'HTTP版本不受支持',
      authError: '认证失败，可以取消继续留在该页面，或者重新登录',
      codeError: '你已被登出，可以取消继续留在该页面，或者重新登录'
    },
    questionpane: {
      answer: '答案',
      radioChoice: '单选题',
      multChoice: '多选题',
      blank: '填空题',
      judge: '判断题',
      QandA: '问答题'
    }
  },
  el: {
    datepicker: {
      now: '此刻',
      today: '今天',
      cancel: '取消',
      clear: '清空',
      confirm: '确定',
      selectDate: '选择日期',
      selectTime: '选择时间',
      startDate: '开始日期',
      startTime: '开始时间',
      endDate: '结束日期',
      endTime: '结束时间',
      year: '年',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      // week: '周次',
      weeks: {
        sun: '日',
        mon: '一',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六'
      },
      months: {
        jan: '一月',
        feb: '二月',
        mar: '三月',
        apr: '四月',
        may: '五月',
        jun: '六月',
        jul: '七月',
        aug: '八月',
        sep: '九月',
        oct: '十月',
        nov: '十一月',
        dec: '十二月'
      }
    }
  }
};
exports["default"] = _default;